/* istanbul ignore file */

import { DefaultTheme } from 'styled-components';

const theme: DefaultTheme = {};

export { theme };
